import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { MercadoFilter } from '../filter';
import { Mercado } from '../mercado';

@Injectable({
    providedIn: 'root'
})
export class MercadoCrudHttpService implements Crud<Mercado> {
    resource = 'mercado';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os mercados cadastrados */
    search(): Observable<Mercado[]> {
        return this.crudService.search<Mercado>(this.resource);
    }

    /** Pesquisa todos os mercados cadastrados utilizando os filtros informados */
    searchWithFilter(filter: MercadoFilter): Observable<Mercado[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<Mercado>(this.resource, {params});
    }

    /** Procura um único mercado através do seu ID */
    find(id: number): Observable<Mercado> {
        return this.crudService.find<Mercado>(this.resource, id);
    }

    /** Carrega um único mercado através do seu ID */
    load(id: number): Observable<Mercado> {
        return this.crudService.load<Mercado>(this.resource, id);
    }

    /** Insere um novo mercado */
    insert(entity: Mercado): Observable<Mercado> {
        return this.crudService.insert<Mercado>(this.resource, entity);
    }

    /** Altera um mercado existente */
    update(entity: Mercado): Observable<Mercado> {
        return this.crudService.update<Mercado>(this.resource, entity);
    }

    /** Exclui um mercado através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
